/**
 * External dependencies
 */
import React from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import Main from 'components/main';
import DocumentHead from 'data/document-head';
import Topbar from 'modules/me/topbar';
import SelectPlan from 'modules/me/select-dispatch-plan';
import CurrentDispatchPlanCard from './index/current-plan-card';
import PlanDetailsCard from './index/plan-details-card';
import { Stack, Text, Heading, Box } from '@towersystems/towersystems-design-system';
import Notice from 'components/notice';

// new
import AnnotatedSection from 'components/annotated-section';
import Button from 'components/button';
import ButtonGroup from 'components/button-group';
import BillingDetailsCard from './index/billing-details-card';

/**
 * Style dependencies
 */
import './styles.scss';

const Dispatch = (props) => {
    return (
        <Box>
            <DocumentHead title='Billing - Manage Dispatch Module Plan - Tower Systems' />
            <Topbar title='Dispatch Module Plan' subTitle='Manage your Dispatch Module plan' selected='dispatch'>
            </Topbar>
            <Main padding='xxlarge'>
                <Stack space='xlarge' dividers>
                    <AnnotatedSection>
                        <AnnotatedSection.Annotation
                            title='Subscription Details'
                            description='Dispatch Module plan details.'
                        />
                        <AnnotatedSection.Content>
                            <CurrentDispatchPlanCard />
                        </AnnotatedSection.Content>
                    </AnnotatedSection>
                </Stack>
            </Main>
        </Box>
    );
};

export default connect(
    (state) => ({
    }),
    {},
)(Dispatch);
